export default __webpack_public_path__ + "static/media/GF.51101469.svg";